__turbopack_context__.v({
  "className": "playfair_display_6c3738b4-module__pRj3qq__className",
  "variable": "playfair_display_6c3738b4-module__pRj3qq__variable",
});
